import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';
import { ILookup, ILookupItem } from '../../api/dtos';
import useInvestigators from '../data/useInvestigators';

export const INVESTIGATOR_LOOKUP_OTHER = "other";

export const useInvestigatorLookup = (propertyName: string, institutionCode?: string, hideOther?: boolean, configuration?: SWRConfiguration) => {
    const output = useInvestigators(institutionCode, configuration);

    const modifiedOutput = useMemo(() => {
        const lookupItems: ILookupItem[] = output.data ?
            Object.keys(output.data).map((key) => {
                return {
                    id: key as any,
                    value: output.data![key]
                }
            }) :
            [];

        if(!hideOther) {
            lookupItems.push({
                id: INVESTIGATOR_LOOKUP_OTHER as any,
                value: 'Other'
            });
        }    

        const lookups: ILookup = {
            propertyName: propertyName,
            items: lookupItems
        };

        return {
            ...output,
            data: lookups
        }
    }, [output, propertyName])

    return modifiedOutput;
};

export default useInvestigatorLookup;